// require everything in root directory
const req = require.context('./', true, /(?!.*test).*\.js$/);
req.keys().forEach((key) => {
  req(key);
});
// or just: req.keys().forEach(req)
